// extracted by mini-css-extract-plugin
export default {"textSpecialShieldRoot":"textSpecialShieldRoot___Nm9Pt","s":"s___IU_zD","m":"m___WwOh2","l":"l___L_04q","textSpecialShieldImg":"textSpecialShieldImg___oyu2u"};